import React, { useEffect, useState } from "react";
import { useForm, UseFormRegister, FieldErrors, UseFormSetValue } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../../../service/validation/vehicle";
import Input from "../../../../components/FormInputs";
import AdminContainer from "../../../Admin";
import { VehicleFormData } from "../../../../service/interfaces/Forms";
import DatePicker from "../../../../components/Datepicker";
import TitleSelect from "../../../../components/Dropdown";
import PhoneInput from "../../../../components/phoneinput";
import { useNavigate, useParams } from "react-router-dom";
import FormTitle from "../../../../components/FormTitle";

interface AddressDetailsProps {
  register: UseFormRegister<VehicleFormData>;
  errors: FieldErrors<VehicleFormData>;
  setValue: UseFormSetValue<VehicleFormData>;
  watch: any;
}
const OwnerDetails: React.FC<AddressDetailsProps> = ({
  register,
  errors,
  setValue,
  watch,
}) => {
  return (
    <div className="bg-white p-6 rounded-[20px] font-poppins">
      <FormTitle title="Insurance Details" />
      <div className="mt-4 grid grid-cols-3 gap-x-6 gap-y-4">
        <Input
          label="Insurance Number"
          name="insuranceDetails.insuranceNumber"
          errors={errors}
          register={register}
          uppercase={true}
          placeholder="Enter insurance number"
          type="text"
        />
        <DatePicker
          label="Insurance Date"
          onDateChange={(date: string) =>
            setValue("insuranceDetails.insuranceDate", new Date(date).toISOString())
          }
          register={register("insuranceDetails.insuranceDate")}
          name="insuranceDetails.insuranceDate"
          errors={errors}
          allowPastDates={true}
          includeTime={false}
          disabled={false}
          defaultValue={watch("insuranceDetails.insuranceDate")}
        />
        <DatePicker
          label="Expiry Date"
          onDateChange={(date: string) =>
            setValue("insuranceDetails.expiryDate", new Date(date).toISOString())
          }
          register={register("insuranceDetails.expiryDate")}
          name="insuranceDetails.expiryDate"
          errors={errors}
          allowPastDates={false}
          includeTime={false}
          disabled={false}
          defaultValue={watch("insuranceDetails.expiryDate")}
        />
      </div>
    </div>
  );
};

export default OwnerDetails;
